import React from 'react';
import Layout from '@/components/layout/Layout';
import DepartmentCostReport from '@/components/finance/reports/DepartmentCostReport';

const DepartmentCostReportPage: React.FC = () => {
  return (
    <Layout>
      <div className="w-full max-w-full py-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Department Cost Analysis</h1>
          <p className="text-muted-foreground mt-1">
            Compare department spending against budgets, identify cost centers, and track trends
          </p>
        </div>
        <DepartmentCostReport />
      </div>
    </Layout>
  );
};

export default DepartmentCostReportPage;
